import * as Immutable from "immutable"
import { BaseEntity } from "../../baseEntity"

export abstract class ColoredInterval extends BaseEntity {

  protected readonly CSS_CLASS = "cssClass";
  protected readonly BEGIN = "begin";
  protected readonly END = "end";

  get cssClass(): string { return this.getInternalValue<string>(this.CSS_CLASS); }
  setCssClass(cssClass: string): this { return this.setInternalValue(this.CSS_CLASS, cssClass); }

  get begin(): string { return this.getInternalValue<string>(this.BEGIN); }
  setBegin(begin: string): this { return this.setInternalValue(this.BEGIN, begin); }

  get end(): string { return this.getInternalValue<string>(this.END); }
  setEnd(end: string): this { return this.setInternalValue(this.END, end); }
 
}
